import { useTheme } from "@mui/material";
export const LoginStyle = () => {
    const theme = useTheme();
    return {
        container: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100svh - 24px)",
            position: "relative",
            overflow: "hidden",
        },
        backgroundImage: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            background: `url('/assets/images/bg.png'), ${theme.palette.primary.darker}`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        loginBox: {
            backgroundColor: "tranparent",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "60px",
        },
        logoContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "36px",
            height: "181px",
            padding: "10px",
        },
        button: {},
    };
};
